import React from "react"
import { HEAD_TITLE } from "../const"
import { HtmlHead } from "./htmlHead"

export const Head = () => {
  return (
    <HtmlHead title={HEAD_TITLE} />
  )
}